interface Validation {
  check(): boolean;
}

interface Remove {
  remove(): string;
}

export class BillingSpaceValidator implements Validation, Remove {
  private _billingNumber = '';
  private readonly _regex = /\s+/g;
  constructor(billingNumber: string) {
    this._billingNumber = billingNumber;
  }

  check(): boolean {
    return this._regex.test(this._billingNumber);
  }

  remove(): string {
    return this._billingNumber.replace(this._regex, '');
  }
}
